import { render } from "./Rotas.vue?vue&type=template&id=847d200c"
import script from "./Rotas.vue?vue&type=script&lang=js"
export * from "./Rotas.vue?vue&type=script&lang=js"

import "./Rotas.vue?vue&type=style&index=0&id=847d200c&lang=css"

import exportComponent from "F:\\Projetos 2024\\e-logDash\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__